import { useEffect, useState } from "react";

const readStoredPreference = (key, fallback) => {
  try {
    return localStorage.getItem(key) || fallback;
  } catch {
    return fallback;
  }
};

const useStoredPreference = (key, fallback) => {
  const [value, setValue] = useState(() => readStoredPreference(key, fallback));

  useEffect(() => {
    try {
      localStorage.setItem(key, value);
    } catch {}
  }, [key, value]);

  return [value, setValue];
};

export default function useAppPreferences() {
  const [appMode, setAppMode] = useStoredPreference("orion33_mode", "complete");
  const [theme, setTheme] = useStoredPreference("orion33_theme", "dark");

  const toggleTheme = () => {
    setTheme((current) => (current === "dark" ? "light" : "dark"));
  };

  return {
    appMode,
    setAppMode,
    theme,
    setTheme,
    toggleTheme,
  };
}
